import { combineEpics } from 'redux-observable';

import playerEventsEpics from './player/epics';
import playerStateEpics from './player/state/epics';
import playerVideoSourceEpics from './player/videoSource/epics';
import uiEpics from './ui/epics';
import uiShareEpics from './ui/share/epics';
import trackingEpics from './tracking/epics';
import adsEpics from './ads/epics';


export default combineEpics(
	playerEventsEpics,
	playerStateEpics,
	playerVideoSourceEpics,
	uiEpics,
	uiShareEpics,
	trackingEpics,
	adsEpics,
);


// WEBPACK FOOTER //
// ./src/epics.js